import { useState, useEffect } from 'react'
import { createContainer } from 'unstated-next'
import { AIAssistantSopNode, AIAssistantNodeType, AIAssistantNode } from 'src/types/ai-assistant'
import { getAIAssistantSop, chatWithAIAssistant } from 'src/services/ai-assistant'
import { message } from 'antd'
import { v4 as uuid } from 'uuid'
function useCallWorkbenchHook () {
  // const [sopNodeList, setSopNodeList] = useState<AIAssistantNode[]>([])
  const [nodeList, setNodeList] = useState<AIAssistantNode[]>([])
  const [sopNodeLoading, setSopNodeLoading] = useState(false)
  const [searchNodeLoading, setSearchNodeLoading] = useState(false)
  const getSopNode = async ({ nodeId, leadId, cid }: { nodeId: string; leadId: number; cid: string }) => {
    setSopNodeLoading(true)
    const [res, err] = await getAIAssistantSop({ nodeId, leadId, cid })
    setSopNodeLoading(false)
    if (err) {
      message.error(err.message)
      return
    }
    setNodeList(nodes => [...nodes, { type: AIAssistantNodeType.assistant, node: res?.node, id: res?.node?.id }])
  }

  const getAISearchNode = async ({ type, content, label }: { type: string; content: string; label?: string }) => {
    const id = uuid()
    setSearchNodeLoading(true)
    await chatWithAIAssistant({ type, content, reqId: id }, {
      onStart: () => {
        const node = {
          id,
          label: label || content,
          words: '',
          done: false,
        }
        setNodeList(nodes => [...nodes, { id, type: AIAssistantNodeType.aiSearch, node }])
      },
      onData: (data) => {
        const word = data ? JSON.parse(data)?.content : ''
        setNodeList(nodes => nodes.map(n => n.id === id ? { ...n, node: { ...n.node, words: n.node.words + word } } : n))
      },
      onError: (error) => {
        setSearchNodeLoading(false)
        console.log('error:', error)
        message.error(error?.message)
      },
      onEnd: () => {
        setSearchNodeLoading(false)
        setNodeList(nodes => nodes.map(n => n.id === id ? { ...n, node: { ...n.node, done: true } } : n))
      },
    })
  }

  return {
    nodeList,
    setNodeList,
    getSopNode,
    sopNodeLoading,
    getAISearchNode,
    searchNodeLoading,
    setSearchNodeLoading,
  }
}

const CallWorkbenchContainer = createContainer(useCallWorkbenchHook)
export default CallWorkbenchContainer
